"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(exports, "__esModule", { value: true });
exports.userAgentMiddlewareFactory = void 0;
var middleware_1 = require("./middleware");
Object.defineProperty(exports, "userAgentMiddlewareFactory", { enumerable: true, get: function () { return middleware_1.userAgentMiddlewareFactory; } });
